import React from 'react';
import classes from './CheckoutSummary.css';
import OrderSummary from '../Burger/OrderSummary/OrderSummary';
import Burger from '../Burger/Burger';
import Spinner from '../UI/Spinner/Spinner';


const checkoutSummary = (props) => {

  let orderSummary = <Spinner />
  let burger = null;

  if (props.ingredients) {
    orderSummary = <OrderSummary prices={props.prices} ingredients={props.ingredients} total={props.total} />
    burger = <Burger ingredients={props.ingredients} />
  }


  return (
    <div className={classes.SummaryContainer}>
      <div className={classes.BurgerContainer}>
        {burger}
      </div>
      <div className={classes.SummaryDetailsContainer}>
        {orderSummary}
      </div>
    </div>
  )

}

export default checkoutSummary;


// WEBPACK FOOTER //
// ./src/components/CheckoutSummary/CheckoutSummary.jsx